









































































import { Component, Ref, Vue } from 'vue-property-decorator'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import { formatarMoeda } from '@/shareds/formatadores'

export type AtributoExibido = {
	nome: string
	valor: string
}

export type ParametrosDePrecoDoItem = {
	nomeDoProduto: string
	atributos: AtributoExibido[]
	preco: number
	descontoPercentual?: number
	permitirReplicar?: boolean
}

export type PrecoDefinidoDoItem = {
	preco: number
	descontoPercentual: number
	replicarNaGrade: boolean
}

@Component({
	components: {
		CampoDecimal,
	},
})
export default class DialogoDePrecoDoItemDaPreVenda extends Vue {
	@Ref() form!: { validate: () => boolean; resetValidation: () => void }
	@Ref() campoDePreco!: CampoDecimal

	mostra = false
	nomeDoProduto = ''
	atributos: AtributoExibido[] = []
	permitirReplicar = false
	preco: number | null = 0
	descontoPercentual: number | null = 0
	replicarNaGrade = false

	formatarMoeda = formatarMoeda

	private resolver: ((resultado: PrecoDefinidoDoItem | null) => void) | null = null
	private temporizadoresDeFoco: ReturnType<typeof setTimeout>[] = []

	mostrar(parametros: ParametrosDePrecoDoItem): Promise<PrecoDefinidoDoItem | null> {
		// se sobrou um pedido pendente (o modal foi reaberto sem resposta), ele é cancelado
		this.responder(null)

		this.nomeDoProduto = parametros.nomeDoProduto
		this.atributos = parametros.atributos || []
		this.permitirReplicar = parametros.permitirReplicar ?? false
		this.preco = parametros.preco ?? 0
		this.descontoPercentual = parametros.descontoPercentual ?? 0
		this.replicarNaGrade = false
		this.mostra = true

		this.$nextTick(() => {
			this.form?.resetValidation()
			this.focarPreco()
		})
		this.insistirNoFocoDoPreco()

		return new Promise(resolve => {
			this.resolver = resolve
		})
	}

	confirmar() {
		if (!this.form.validate()) return

		this.responder({
			preco: Number(this.preco) || 0,
			descontoPercentual: Number(this.descontoPercentual) || 0,
			replicarNaGrade: this.replicarNaGrade,
		})
		this.fechar()
	}

	cancelar() {
		this.responder(null)
		this.fechar()
	}

	private fechar() {
		this.limparTemporizadoresDeFoco()
		this.mostra = false
	}

	/**
	 * Quando o modal abre no fim da bipagem, o campo de código de barras recupera o foco depois
	 * de limpar o v-model dele, e o foco do preço se perde. Por isso o foco é reaplicado até o
	 * modal estabilizar, sempre respeitando quem o operador já escolheu dentro do modal.
	 */
	private insistirNoFocoDoPreco() {
		this.limparTemporizadoresDeFoco()
		this.temporizadoresDeFoco = [120, 320].map(atraso => setTimeout(() => this.focarPreco(), atraso))
	}

	private limparTemporizadoresDeFoco() {
		this.temporizadoresDeFoco.forEach(temporizador => clearTimeout(temporizador))
		this.temporizadoresDeFoco = []
	}

	/**
	 * O CampoDecimal engole qualquer tecla quando o valor já está com as duas casas decimais
	 * (ver trocarTecla em CampoDecimalBase), o que derruba o Tab e o Enter. Aqui as duas teclas
	 * são tratadas na fase de captura, antes de o componente vê-las.
	 */
	aoTeclarNoCampo(evento: KeyboardEvent) {
		if (evento.key === 'Tab') {
			evento.stopPropagation()
			return
		}

		if (evento.key === 'Enter') {
			evento.stopPropagation()
			evento.preventDefault()
			this.confirmar()
		}
	}

	private responder(resultado: PrecoDefinidoDoItem | null) {
		const resolver = this.resolver
		this.resolver = null
		if (resolver) resolver(resultado)
	}

	focarPreco() {
		const campo: any = this.campoDePreco
		if (!campo) return

		// se o operador já escolheu um campo do modal, o foco é dele. A comparação é por campo
		// de verdade porque o próprio v-dialog recebe foco ao abrir, e aí o foco inicial seria pulado
		const modal: HTMLElement | null = campo.$el?.closest('.v-dialog') ?? null
		const ativo = document.activeElement as HTMLElement | null
		const estaEmCampoDoModal = !!modal && !!ativo && modal.contains(ativo)
			&& ['INPUT', 'TEXTAREA', 'BUTTON'].includes(ativo.tagName)
		if (estaEmCampoDoModal) return

		if (typeof campo.focus === 'function') {
			campo.focus()
			return
		}

		const input: HTMLInputElement | null = campo.$el?.querySelector('input') ?? null
		if (input) {
			input.focus()
			input.select?.()
		}
	}

	get precoComDesconto(): number {
		const preco = Number(this.preco) || 0
		const desconto = Number(this.descontoPercentual) || 0
		if (desconto <= 0) return preco
		return Math.round(preco * (1 - desconto / 100) * 100) / 100
	}

	get precoEValido() {
		return () => {
			const preco = Number(this.preco) || 0
			if (preco <= 0) return 'Informe um preço maior que zero'
			return true
		}
	}

	get descontoEValido() {
		return () => {
			const desconto = Number(this.descontoPercentual) || 0
			if (desconto < 0) return 'Desconto não pode ser negativo'
			if (desconto > 99.99) return 'Desconto não pode ser maior que 99.99%'
			return true
		}
	}
}
